import { request } from './core.api';

export interface ProfileDto {
  email: string;
  displayName: string;
  providerDisplayName?: string | null;
  customDisplayName?: string | null;
  allowedCountryCodes?: string[];
  advertisingEnabled?: boolean;
  accountMode?: 'landlord' | 'tenant';
  firstName?: string | null;
  lastName?: string | null;
  isBusinessAccount?: boolean;
  companyName?: string | null;
  vatNumber?: string | null;
  street?: string | null;
  houseNumber?: string | null;
  postalCode?: string | null;
  city?: string | null;
  country?: string | null;
  billingStreet?: string | null;
  billingHouseNumber?: string | null;
  billingPostalCode?: string | null;
  billingCity?: string | null;
  billingCountry?: string | null;
  providerCustomerId?: string | null;
  subscriptionPlanKey?: string | null;
  subscriptionInterval?: string | null;
  subscriptionStatus?: string | null;
  subscriptionCancelAtPeriodEnd?: boolean;
  subscriptionCurrentPeriodEndUtc?: string | null;
  accountAccessRole?: 'owner' | 'manager' | 'reader';
  canManageAccount?: boolean;
}

export interface UpdateProfileRequest {
  customDisplayName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  isBusinessAccount?: boolean | null;
  companyName?: string | null;
  vatNumber?: string | null;
  street?: string | null;
  houseNumber?: string | null;
  postalCode?: string | null;
  city?: string | null;
  country?: string | null;
  billingStreet?: string | null;
  billingHouseNumber?: string | null;
  billingPostalCode?: string | null;
  billingCity?: string | null;
  billingCountry?: string | null;
}

export interface SwitchAccountModeRequest {
  accountMode: 'landlord' | 'tenant';
}

export interface SwitchAccountModeResultDto {
  accountMode: 'landlord' | 'tenant';
  trialStarted: boolean;
  requiresPaidPlan: boolean;
}

export interface AccountMemberDto {
  id: string;
  email: string;
  displayName: string;
  providerDisplayName: string;
  accessRole: 'owner' | 'manager' | 'reader';
  isCurrentUser: boolean;
  isOwner: boolean;
}

export interface AccountMemberInviteDto {
  id: string;
  email: string;
  accessRole: 'owner' | 'manager' | 'reader';
  createdAtUtc: string;
  inviteUrl: string;
}

export interface AccountMembersOverviewDto {
  currentAccessRole: 'owner' | 'manager' | 'reader';
  canManageAccount: boolean;
  members: AccountMemberDto[];
  pendingInvites: AccountMemberInviteDto[];
}

export interface InviteAccountMemberRequest {
  email: string;
  accessRole: 'manager' | 'reader';
}

export interface ClaimAccountMemberInviteRequest {
  token: string;
}

export const profileApi = {
  get: () => request<ProfileDto>('/profile'),
  update: (body: UpdateProfileRequest) => request<ProfileDto>('/profile', {
    method: 'PUT',
    body: JSON.stringify(body),
  }),
  switchAccountMode: (body: SwitchAccountModeRequest) => request<SwitchAccountModeResultDto>('/profile/account-mode', {
    method: 'POST',
    body: JSON.stringify(body),
  }),
  getAccountMembers: () => request<AccountMembersOverviewDto>('/profile/account-members'),
  inviteAccountMember: (body: InviteAccountMemberRequest) => request<AccountMemberInviteDto>('/profile/account-members', {
    method: 'POST',
    body: JSON.stringify(body),
  }),
  claimAccountMemberInvite: (body: ClaimAccountMemberInviteRequest) => request<void>('/profile/account-members/claim', {
    method: 'POST',
    body: JSON.stringify(body),
  }),
  removeAccountMember: (memberUserId: string) => request<void>(`/profile/account-members/${encodeURIComponent(memberUserId)}`, {
    method: 'DELETE',
  }),
};
